import { render, staticRenderFns } from "./HomeStartScreen.vue?vue&type=template&id=3e43628e&scoped=true"
import script from "./HomeStartScreen.vue?vue&type=script&lang=ts"
export * from "./HomeStartScreen.vue?vue&type=script&lang=ts"
import style0 from "./HomeStartScreen.vue?vue&type=style&index=0&id=3e43628e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e43628e",
  null
  
)

export default component.exports